// Re-export from sonner with our styling
export { Toaster } from 'sonner';
// Re-export toast function with typed variants
import { toast as sonnerToast } from 'sonner';
export const toast = {
    success: (message, opts) => sonnerToast.success(message, opts),
    error: (message, opts) => sonnerToast.error(message, opts),
    warning: (message, opts) => sonnerToast.warning(message, opts),
    info: (message, opts) => sonnerToast.info(message, opts),
    loading: (message, opts) => sonnerToast.loading(message, opts),
    promise: sonnerToast.promise,
    dismiss: sonnerToast.dismiss,
};
//# sourceMappingURL=Toast.js.map